<template>
  <div>
    <Loading v-if="loading"/>
    <div v-if="isAuthenticated">
      <AppHeader/>

      <section class="main-menu navbar-space">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-12">
              <div class="secondary-title">
                <h5 class="title">ประวัติการทำรายการ</h5>
              </div>
            </div>
          </div>
          <div v-if="appList.length > 0" class="row justify-content-center">
            <div class="col-12 col-xs-fix">
              <div class="purchase-table-wrapper table-wrapper">
                <table class="purchase-table table">
                  <thead>
                    <tr>
                      <th scope="col">รายการ</th>
                      <th scope="col">เลขที่ใบคำขอ</th>
                      <th scope="col">ประเภท</th>
                      <th scope="col">วันที่ทำรายการ</th>
                      <th scope="col">สถานะ</th>
                      <th class="amt-th" scope="col">วงเงินค้ำประกัน</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      class="main-row"
                      v-for="(item, index) in appList"
                      v-bind:item="item"
                      v-bind:index="index"
                      v-bind:key="item.appId"
                    >
                      <td class="name-cell">
                        <div class="security-img">
                          <img :src="require(`@/resources/img/bene/${item.logoCd}.jpg`)" alt>
                        </div>
                        <div class="security-name">
                          <a @click="getRequestDetail(item.reqNo)">{{item.beneNameTh}}</a>
                          <div class="name-cell small">({{reqTypeMapping(item.reqType)}})</div>
                        </div>
                        
                      </td>
                      <td class="name-cell">{{item.reqNo}} </td>
                      <td class="name-cell">{{item.lgTypeNameTh}}</td>
                      <td class="date-cell">{{item.createDt}}</td>
                      <td class="status-cell">
                        <div v-if="item.status === 'S'" class="status-wrapper status-success">
                          <span>สำเร็จ</span>
                        </div>
                        <div v-if="item.status === 'F'" class="status-wrapper status-danger">
                          <span>ไม่สำเร็จ</span>
                        </div>
                        <div v-if="item.status === 'W'" class="status-wrapper status-wait">
                          <span>กำลังดำเนินการ</span>
                        </div>
                        <div v-if="item.status === 'R'" class="status-wrapper status-danger">
                          <span>ไม่ผ่านเงื่อนไข</span>
                        </div>
                      </td>
                      <td class="amt-cell">
                        <span class="amt-cur">{{formatPrice(item.lgAmt)}} บาท</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <b-pagination
              size="md"
              :total-rows="totalRecord"
              v-model="currentPage"
              :per-page="10"
              @input="getRequestHistory(currentPage)"
            ></b-pagination>
          </div>
          <div v-if="appList.length === 0" class="row justify-content-center">
            <div class="col-12 col-xs-fix">
              <div class="purchase-table-wrapper table-wrapper">
                <table class="purchase-table table">
                  <thead>
                    <tr>
                      <th scope="col">รายการ</th>
                      <th scope="col">เลขที่ใบคำขอ</th>
                      <th scope="col">ประเภท</th>
                      <th scope="col">วันที่ทำรายการ</th>
                      <th scope="col">สถานะ</th>
                      <th class="amt-th" scope="col">วงเงินค้ำประกัน</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="empty-data">
                      <td colspan="999">ไม่มีข้อมูลประวัติการทำรายการ</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </section>

      <AppFooter/>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import AppFooter from "../pagecomp/appFooter";
import AppHeader from "../pagecomp/appHeader";
import { AUTH_LOGOUT } from "@/store/actions/auth";
import { mapGetters } from "vuex";
import axios from "axios";
import Loading from "@/components/lib/loading";
import { apiClient } from "@/utils/apiClient";
import moment from "moment";

export default {
  components: {
    AppFooter,
    AppHeader
  },
  name: "apphistory",
  data() {
    return {
      appList: [],
      currentPage: 1,
      limitPage: 10,
      totalRecord: 0,
      appVo:null,
    };
  },
  computed: {
    ...mapGetters(["isAuthenticated", "authStatus"]),
    loading: function() {
      return this.authStatus === "loading" && !this.isAuthenticated;
    },
    getImgUrl(pet) {
      console.log(pet);
      var images = require.context(
        "../../resources/img/bene/",
        false,
        /\.jpg$/
      );
      return images("./" + pet + ".jpg");
    }
  },
  methods: {
    formatPrice(value) {
        let val = (value/1).toFixed(2).replace(',', '.')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },
    escapeHtml: function(unsafe) {
    return unsafe
         .replace(/&/g, "&amp;")
         .replace(/</g, "&lt;")
         .replace(/>/g, "&gt;")
         .replace(/"/g, "&quot;")
         .replace(/'/g, "&#039;");
    },
    reqTypeMapping(tmpReqType){
      let returnType ="ออกหนังสือค้ำประกัน";
      if(tmpReqType==="NEW"){
        returnType ="ออกหนังสือค้ำประกัน";
      }else if(tmpReqType==="INC"){
        returnType ="เพิ่มวงเงินหนังสือค้ำประกัน";

      }else if(tmpReqType==="EXT"){
        returnType ="ต่ออายุหนังสือค้ำประกัน";
        
      }else if(tmpReqType==="EXTINC"){
        returnType ="ต่ออายุ+เพิ่มวงเงิน";        
      }

      return returnType;
    },
    getRequestHistory: function(currentPage) {
      this.loader = this.$loading.show();
      apiClient
        .get("/api/elg/history/" + currentPage + "/" + this.limitPage)
        .then(resp => {
          this.appList = resp.data.list;
          this.totalRecord = resp.data.fullListSize;
          this.loader.hide();
          window.scrollTo(0, 0);
        })
        .catch(err => {
          if(err.response.status===401){
            this.loader.hide();
          }
        //  this.$swal("Error!", "" + err, "error");
        });
    },
    getRequestDetail: function(reqNo) {
      this.loader = this.$loading.show();
      apiClient
        .get("/api/elg/getHistoryDetail/" + reqNo)
        .then(resp => {

          let appVo = resp.data;

          var periodDateStr = "";
          if (appVo.periodType == 2) {
              if(appVo.periodStartDateStr !== '' && appVo.periodEndDateStr !== ''){
                  periodDateStr = appVo.periodStartDateStr + " ถึง " + appVo.periodEndDateStr;
              }else{
                  let periodStartDate = moment(String(appVo.periodStartDate)).format("DD/MM/YYYY");
                  let periodEndDate = moment(String(appVo.periodEndDate)).format("DD/MM/YYYY");
                  periodDateStr = periodStartDate + " ถึง " + periodEndDate;
              }
            
          } else {
              if(appVo.periodStartDateStr !== ''){
                  periodDateStr = appVo.periodStartDateStr;
              }else{
                  let periodStartDate = moment(String(appVo.periodStartDate)).format("DD/MM/YYYY");
                  periodDateStr = periodStartDate;
              }
          }

          let createDt = appVo.createDt;
          var strRequest ="";     
          if(appVo.requesterList!=null&&appVo.requesterList.length>0){
            for(var i=0;i<appVo.requesterList.length;i++){
              strRequest=strRequest+"<li>"+this.escapeHtml(appVo.requesterList[i].guaranteeTaxId)+" : "+this.escapeHtml(appVo.requesterList[i].guaranteeName)+"</li>";
            }
          }

          var strUpload ="";
          
          if(appVo.uploadList!=null&&appVo.uploadList.length>0){
            for(var i=0;i<appVo.uploadList.length;i++){
              strUpload=strUpload+"<li>"+this.escapeHtml(appVo.uploadList[i].documentName)+"</li>";
            }
          }

          var strFee ="ค่าธรรมเนียมขั้นต่ำ 500 บาท หรือเป็นไปตามระเบียบธนาคาร";
          if(appVo.bcFlag ==='1'){
            strFee = this.formatPrice(appVo.feeAmt);
          }

          var strRemark1 = "";
          if(appVo.status==='F'){
            strRemark1= "ไม่สามารถออกหนังสือค้ำประกันได้เนื่องจากระบบขัดข้อง";
          }else if(appVo.status==='R'){
            strRemark1 = appVo.message;
          }

          var strRemark2 = "";
          if(strRemark1!==""){
            strRemark2 = "โปรดติดต่อหน่วยงานอำนวยสินเชื่อที่ดูแลท่าน<br>โทร. 02-111-1111 หรือ 02-111-9999";
          }

          var strRemark = "";
          if(appVo.status==='F'||appVo.status==='R'){
            strRemark = " " +
                "      </div>" +
                "    </div>" +

                "    <div class='form-row'>" +   
                "      <div class='form-group-warn col-md-5'>" +
                "        <label>หมายเหตุ</label>" +
                "      </div>" +
                "      <div class='text-sum-warn' col-md-7>" +
                "       " +

                strRemark1 +
                " " +
                "      </div>" +
                "    </div>" +
                "    <div class='form-row'>" +   
                "      <div class='form-group-warn col-md-5'>" +
                "        <label></label>" +
                "      </div>" +  
                "      <div class='text-sum-warn col-md-7'>" +
                "       " +
                strRemark2 ;
          }

          this.$swal
            .fire({
              title: "รายละเอียดใบคำขอ",
              width: 600,
              html:
                "<div class='card-body compact-padding'>" +
                "  <div class='default-padding'>" +
                "    <div class='form-row'>" +
                "      <div class='form-group-sum col-md-5'>" +
                "        <label>หมายเลขอ้างอิงรายการ</label>" +
                "      </div>" +
                "      <div class='text-sum col-md-7'>" +
                "       " +
                appVo.reqNo +
                " " +
                "      </div>" +
                "    </div>" +

                "    <div class='form-row'>" +
                "      <div class='form-group-sum col-md-5'>" +
                "        <label>Contingent No</label>" +
                "      </div>" +
                "      <div class='text-sum col-md-7'>" +
                "       " +
                (appVo.contingentNo===null?"":appVo.contingentNo) +
                " " +
                "      </div>" +
                "    </div>" +                
                "    <div class='form-row'>" +
                "      <div class='form-group-sum col-md-5'>" +
                "        <label>ผู้ขอออกหนังสือค้ำประกัน</label>" +
                "      </div>" +
                "      <div class='text-sum col-md-7'>" +
                "       " +
                this.escapeHtml(appVo.requesterTaxId) +
                " " +
                this.escapeHtml(appVo.requesterNameTh) +
                " " +
                "      </div>" +
                "    </div>" +
                "    <div class='form-row'>" +
                "      <div class='form-group-sum col-md-5'>" +
                "        <label>ผู้รับผลประโยชน์</label>" +
                "      </div>" +
                "      <div class='text-sum col-md-7'>" +
                "       " +
                this.escapeHtml(appVo.beneNameTh) +
                " " +
                "      </div>" +
                "    </div>" +
                "    <div class='form-row'>" +
                "      <div class='form-group-sum col-md-5'>" +
                "        <label>ประเภทการค้ำประกัน</label>" +
                "      </div>" +
                "      <div class='text-sum col-md-7'>" +
                "       " +
                this.escapeHtml(appVo.lgTypeNameTh) +
                " " +
                "      </div>" +
                "    </div>" +

                "    <div class='form-row'>" +   
                "      <div class='form-group-sum col-md-5'>" +
                "        <label>เพื่อค้ำประกันในนาม</label>" +
                "      </div>" +
                "      <div class='text-sum col-md-7'>" +
                "       " +
                strRequest +
                " " +
                "      </div>" +
                "    </div>" +
                
                "    <div class='form-row'>" +
                "      <div class='form-group-sum col-md-5'>" +
                "        <label>จำนวนเงินค้ำประกัน (บาท)</label>" +
                "      </div>" +
                "      <div class='text-sum col-md-7'>" +
                "       " +
                this.formatPrice(appVo.lgAmt) +
                " " +
                "      </div>" +
                "    </div>" +

                "    <div class='form-row'>" +
                "      <div class='form-group-sum col-md-5'>" +
                "        <label>มีผลบังคับใช้ตั้งแต่วันที่</label>" +
                "      </div>" +
                "      <div class='text-sum col-md-7'>" +
                "       " +
                periodDateStr +
                " " +
                "      </div>" +
                "    </div>" +
                "    <div class='form-row'>" +
                "      <div class='form-group-sum col-md-5'>" +
                "        <label>วันที่ทำรายการ</label>" +
                "      </div>" +
                "      <div class='text-sum col-md-7'>" +
                "       " +
                createDt +
                " " +
                "      </div>" +
                "    </div>" +                
                "    <div class='form-row'>" +
                "      <div class='form-group-sum col-md-5'>" +
                "        <label>ค่าธรรมเนียม (บาท)</label>" +
                "      </div>" +
                "      <div class='text-sum col-md-7'>" +
                "       " +
                strFee +
                " " +
                "      </div>" +
                "    </div>" +
                "    <div class='form-row'>" +
                "      <div class='form-group-sum col-md-5'>" +
                "        <label>ค่าอากรแสตมป์ (บาท)</label>" +
                "      </div>" +
                "      <div class='text-sum col-md-7'>" +
                "       " +
                this.formatPrice(appVo.dutyStampAmt) +
                " " +
                "      </div>" +
                "    </div>" +

                "    <div class='form-row'>" +   
                "      <div class='form-group-sum col-md-5'>" +
                "        <label>เอกสารแนบ</label>" +
                "      </div>" +
                "      <div class='text-sum col-md-7'>" +
                "       " +
                strUpload +
                strRemark+
                
                " " +
                "      </div>" +
                "    </div>" +

                "  </div>" +
                "</div>",

              //type: 'warning',
              showCancelButton: false,
              confirmButtonColor: "#3085d6",
              confirmButtonText: "ปิดรายละเอียด"
            });




          this.loader.hide();
        })
        .catch(err => {
          this.loader.hide();
          this.$swal("Error!", "" + err, "error");
        });
    }    
  },

  mounted() {
    this.getRequestHistory(this.currentPage);
    // apiClient.get("/api/test/history").then(resp => {
    //   this.appList = resp.data;
    // });
  }
};
</script>
